import { PackagingUnitUsageInEvalDialogComponent } from '../../../dialogs/packaging-unit-usage-in-eval-dialog/packaging-unit-usage-in-eval-dialog.component';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HistoryWrapperLifeCycle } from '../../../../data-transfer/entities/evaluation-entities/history-wrapper-life-cycle';
import { ComparisonDataService } from '../../../../navigation/services/comparison-data-service';
import { SimpleConfirmDialogComponent } from '../../../dialogs/simple-confirm-dialog/simple-confirm-dialog.component';
import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { SimpleAlertDialogComponent, SimpleDialogData } from '../../../dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { SelectLocationDialogComponent } from '../../dialogs/select-location-dialog/select-location-dialog.component';
import { PackagingUnitTypeService } from '../../../../navigation/services/packaging-unit-type-service';
import { flatten, TranslocoService } from '@jsverse/transloco';
import { DeleteDialogData, DeleteItemDialogComponent } from '../../../dialogs/delete-item-dialog/delete-item-dialog.component';
import { forkJoin, of, Observable, map } from 'rxjs';
import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, AfterViewInit, OnInit, LOCALE_ID, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { PackagingUnitNavigationService } from 'src/app/navigation/services/navigation-services/packaging-unit-navigation.service';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { PermissionTypeDto } from 'src/app/data-transfer/entities/permission-type-dto';
import { PackagingUnitInfoDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-info-dto';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DirectoryDto } from 'src/app/data-transfer/entities/directory-dto';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { DeletedEntitiesDto } from 'src/app/data-transfer/entities/deleted-entities-dto';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { UserApiService } from 'src/app/data-transfer/services/user-api-service';
import { PackagingUnitApiService } from 'src/app/data-transfer/services/packaging-unit-api-service';
import { AnalysisApiService } from 'src/app/data-transfer/services/analysis-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import { HistoryWrapperRecyclability } from 'src/app/data-transfer/entities/evaluation-entities/history-wrapper-recyclability';
import { EditQuantitiesDialogComponent } from '../quantities/edit-quantities-dialog/edit-quantities-dialog.component';
import { EditQuantityDialogComponent } from '../quantities/edit-quantity-dialog/edit-quantity-dialog.component';
import { TemplateApiService } from 'src/app/data-transfer/services/template-api-service';
import { downloadDocument } from 'src/app/services/document-download';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginationFilterDto } from 'src/app/data-transfer/entities/pagination-filter-dto';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PackagingUnitPaginationFields } from 'src/app/data-transfer/entities/pagination-fields';
import { DataExchangeSubRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-sub-request-dto';
import { CreateDocRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-request-dto';
import { CreateDocTdRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-td-request';
import { ColumnDefinitionDto } from 'src/app/data-transfer/entities/user-profile-dto';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { BaseDataApiService } from 'src/app/data-transfer/services/base-data-api-service';
import { FillingGoodTypeDto } from 'src/app/data-transfer/entities/filling-good-type-dto';
import { FillingGoodCategoryDto } from 'src/app/data-transfer/entities/filling-good-category-dto';
import { FillingGoodDto } from 'src/app/data-transfer/entities/filling-good-dto';
import { PpwrApiService } from 'src/app/data-transfer/services/ppwr-api.service';
import { OverviewTableComponent } from 'src/app/components/shared-components/parent-components/overview-table/overview-table.component';

@Component({
  selector: 'app-packaging-units-overview',
  templateUrl: './packaging-units-overview.component.html',
  styleUrls: ['./packaging-units-overview.component.scss'],
})
export class PackagingUnitsOverviewComponent extends OverviewTableComponent implements OnInit, OnChanges, AfterViewInit {
  private _dataSource!: PaginationDataSource<PackagingUnitInfoDto> | MatTableDataSource<PackagingUnitInfoDto>;

  @Input()
  set dataSource(value: typeof this._dataSource) {
    this._dataSource = value;
    this.isPaginatorVisible = value instanceof PaginationDataSource;
  }
  get dataSource() {
    return this._dataSource;
  }

  @Input() isUserValidator = false;
  @Input() isRecyclingBinSelected = false;
  @Input() displayedColumns: string[] = [];
  @Input() subRequestMap?: Map<number, DataExchangeSubRequestDto>;
  @Input() commentCountMap?: Map<number, number>;
  @Input() public analysisWrappersRec?: HistoryWrapperRecyclability[];
  @Input() public analysisWrappersLca?: HistoryWrapperLifeCycle[];
  @Input() form: FormGroup = this.formBuilder.group({ quantityForms: this.formBuilder.array([]) });
  @Input() directoryIds?: number[];
  @Input() packagingTypeId: number | undefined;

  @Output() dataChanged = new EventEmitter();
  @Output() distributionCountryAdded = new EventEmitter();
  @Output() infoButtonClick = new EventEmitter<PackagingUnitDto | PackagingUnitInfoDto>();
  @Output() navigateToSubRequest = new EventEmitter<number>();
  @Output() approveSubRequest = new EventEmitter<number>();
  @Output() reopenSubRequest = new EventEmitter<number>();
  @Output() withdrawSubRequest = new EventEmitter<number>();
  @Output() showSubRequestComments = new EventEmitter<number>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  callerLevelId = PackagingPart.Unit;
  private packagingUnitIds: number[] = [];
  selectedPackagingUnitIds: number[] = [];
  isLoading = of(false);

  suppliers: string[] = [];
  directories: { name: string; value: number }[] = [];
  fillingGoodTypes: FillingGoodTypeDto[] = [];
  fillingGoodCategories: FillingGoodCategoryDto[] = [];
  fillingGoods: FillingGoodDto[] = [];

  protected columnSettingsTableType = PackagingPart[PackagingPart.Unit];
  protected entityLabelKey = 'packagingUnit.packagingUnit';
  protected readonly columnCatalog: ColumnDefinitionDto[] = [
    { key: 'id', labelKey: 'commonPackagingFields.id' },
    { key: 'tags', labelKey: 'dataManagement.tags.titleTags' },
    { key: 'tracking', labelKey: 'dataManagement.tracking' },
    // Verpackungsinformationen
    { key: 'packagingTypeName', labelKey: 'packagingUnit.packagingUnitType' },
    { key: 'brandName', labelKey: 'packagingUnit.fields.brandName' },
    { key: 'productName', labelKey: 'packagingUnit.fields.productName' },
    { key: 'articleNumber', labelKey: 'packagingUnit.fields.articleNumber' },
    { key: 'gtin', labelKey: 'packagingUnit.fields.gtin' },
    // Füllmaterial
    { key: 'fillingGoodTypeId', labelKey: 'packagingUnit.fields.fillingGoodProductRange' },
    { key: 'fillingGoodCategoryId', labelKey: 'packagingUnit.fields.fillingGoodCategory' },
    { key: 'fillingGoodId', labelKey: 'packagingUnit.fields.fillingGoodProductCategory' },
    { key: 'packagingQuantity', labelKey: 'packagingUnit.fields.fillingQuantity' },
    { key: 'packagingVolume', labelKey: 'packagingUnit.fields.fillingVolume' },
    // Herstellungsinformationen
    { key: 'distributionCountries', labelKey: 'packagingUnit.fields.countriesOfDistribution' },
    { key: 'assemblyCountry', labelKey: 'packagingUnit.fields.assemblyCountry' },
    { key: 'supplier', labelKey: 'packagingUnit.fields.supplier' },
    // Produkt Dimensionen
    { key: 'length', labelKey: 'component.fields.length' },
    { key: 'width', labelKey: 'component.fields.width' },
    { key: 'height', labelKey: 'component.fields.height' },
    // Sonstiges
    { key: 'packagingLevel', labelKey: 'packagingUnit.fields.packagingLevelHeader' },
    { key: 'isPackagingPartOfProduct', labelKey: 'home.filter.isPackagingPartOfProductShort' },
    { key: 'isMultiUsePackaging', labelKey: 'home.filter.isMultiUsePackagingShort' },
    // Herkunft (nicht in deiner Liste, aber bereits bestehend)
    { key: 'creationTimestamp', labelKey: 'commonPackagingFields.creationDate' },
    { key: 'lastModificationTimestamp', labelKey: 'commonPackagingFields.lastModificationDate' },
    // Upload-Bereiche
    { key: 'hasPPWRDocuments', labelKey: 'home.filter.technicalDocumentationDataShort' },
    { key: 'hasImagess', labelKey: 'image.productImages' },
    { key: 'hasCertificates', labelKey: 'certificate.certificates' },
    { key: 'hasAdditionalDocuments', labelKey: 'pdf.productPdfs' },
    { key: 'action', labelKey: 'dataManagement.actions' },
  ];
  isPaginatorVisible = false;

  constructor(
    private templateApiService: TemplateApiService,
    private packagingUnitApiService: PackagingUnitApiService,
    private analysisApiService: AnalysisApiService,
    private comparisonDataService: ComparisonDataService,
    private formBuilder: FormBuilder,
    private packagingUnitTypeService: PackagingUnitTypeService,
    protected dialog: MatDialog,
    protected directoryApiService: DirectoryApiService,
    protected importExportApiService: ImportExportApiService,
    protected navigationService: PackagingUnitNavigationService,
    protected translateService: TranslocoService,
    protected userApiService: UserApiService,
    protected ppwrApiService: PpwrApiService,
    protected coreDataUpdateService: CoreDataUpdateService,
    protected spinner: NgxSpinnerService,
    public cd: ChangeDetectorRef,
    @Inject(LOCALE_ID) public locale: string,
    private dataExchangeRequestApiService: DataExchangeRequestApiService,
    private baseDataApiService: BaseDataApiService
  ) {
    super(dialog, directoryApiService, importExportApiService, navigationService, translateService, userApiService, coreDataUpdateService, spinner, locale);
    this.dataSource = new MatTableDataSource<PackagingUnitInfoDto>();
  }

  get quantityForms(): FormArray {
    return this.form.controls.quantityForms as FormArray;
  }

  ngOnInit(): void {
    if (this.isUserValidator) {
      this.displayedColumns.push('validation');
      this.displayedColumns.push('organizationId');
      this.displayedColumns.push('creationTimestamp');
      this.organizationsSubscription = this.userApiService.getOrganizations().subscribe(organizations => (this.organizations = organizations));
    }

    if (this.displayedColumns.includes('supplier')) {
      this.packagingUnitApiService.getSuppliers().subscribe(x => (this.suppliers = x));
    }

    if (this.displayedColumns.includes('directoryName')) {
      this.directoryApiService.getDirectories().subscribe(dir => (this.directories = this.flattenDirectories(dir)));
    }

    this.baseDataApiService.getFillingGoodTypes().subscribe(types => (this.fillingGoodTypes = types));
    this.baseDataApiService.getFillingGoodCategories().subscribe(categories => (this.fillingGoodCategories = categories));
    this.baseDataApiService.getFillingGoods().subscribe(goods => (this.fillingGoods = goods));

    this.loadColumnSettings();
  }

  ngAfterViewInit(): void {
    if (this.dataSource instanceof PaginationDataSource) {
      this.ngAfterViewInitPagination(this.dataSource);
    } else {
      this.ngAfterViewInitStatic(this.dataSource);
    }
  }

  private ngAfterViewInitPagination(dataSource: PaginationDataSource<PackagingUnitInfoDto>): void {
    this.refreshDataSource();
    dataSource.page.subscribe(page => {
      this.paginator.length = page.totalItemCount;
      this.paginator.pageIndex = page.pageIndex;
      this.packagingUnitIds = page.allIds;
      this.selectedPackagingUnitIds = this.selectedPackagingUnitIds.filter(id => page.allIds.includes(id));
    });
    dataSource.filteredColumns.subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
    });
    this.cd.detectChanges();
  }

  private ngAfterViewInitStatic(dataSource: MatTableDataSource<PackagingUnitInfoDto>): void {
    dataSource.sort = this.sort;
    dataSource.sortingDataAccessor = (data: PackagingUnitInfoDto, sortHeaderLabel: string) => {
      let value;
      if (sortHeaderLabel === 'quantityInput') {
        value = this.form.value.quantityForms.find((quantityEntry: any) => quantityEntry.id === data.id).quantity;
      } else if (sortHeaderLabel === 'analysisId') {
        value = this.getAnalysisIdForPackaging(data.id);
      } else if (sortHeaderLabel === 'subRequestStatus') {
        value = this.translateService.translate(this.getSubRequestStatusLabel(this.subRequestMap?.get(data.id)?.status));
      } else {
        value = data[sortHeaderLabel as keyof PackagingUnitInfoDto];
      }
      return typeof value === 'string' ? value.toLowerCase() : value;
    };
  }

  protected getFilterValue(data: PackagingUnitDto | PackagingUnitInfoDto, key: string): any {
    if (key === 'subRequestStatus') {
      return this.translateService.translate(this.getSubRequestStatusLabel(this.subRequestMap?.get(data.id)?.status));
    }

    return super.getFilterValue(data, key);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (this.dataSource instanceof PaginationDataSource) {
      this.ngOnChangesPagination(changes);
    } else {
      this.ngOnChangesStatic(changes, this.dataSource);
    }
  }

  private ngOnChangesPagination(changes: SimpleChanges): void {
    if (changes.dataSource != null) {
      this.selectedPackagingUnitIds = [];
    }
    if ((changes.directoryIds || changes.isRecyclingBinSelected) && this.paginator) {
      this.refreshDataSource();
      return;
    }
  }

  private ngOnChangesStatic(changes: SimpleChanges, dataSource: MatTableDataSource<PackagingUnitInfoDto>): void {
    if (changes.dataSource != null) {
      super.setDataSourceFilter(dataSource);
      this.updateDisplayTrackedColumn(dataSource);
      this.dataSourceSubscription = dataSource.connect().subscribe(_ => {
        this.updateDisplayTrackedColumn(dataSource);
      });
      this.selectedPackagingUnitIds = [];
    }
  }

  private refreshDataSource() {
    if (!(this.dataSource instanceof PaginationDataSource)) {
      return;
    }

    if (!this.isRecyclingBinSelected && this.directoryIds != null && this.directoryIds.length === 0) {
      this.dataSource.clear();
      return;
    }

    let filters: PaginationFilterDto[] = [];

    if (!this.isRecyclingBinSelected && this.directoryIds && this.directoryIds.length > 0) {
      filters = [{ fieldName: 'DirectoryId', values: this.directoryIds.map(id => id.toString()) }];
    }

    if (this.packagingTypeId) {
      filters.push({ fieldName: 'PackagingType', values: [this.packagingTypeId.toString()] });
    }

    this.dataSource.fetchData(this.paginator.pageIndex, this.paginator.pageSize, filters);
  }

  setPackagingUnitSelected(checked: boolean, item: PackagingUnitInfoDto) {
    if (checked) {
      this.selectedPackagingUnitIds.push(item.id);
    } else {
      const index = this.selectedPackagingUnitIds.indexOf(item.id);
      this.selectedPackagingUnitIds.splice(index, 1);
    }
    this.packagingPartsSelected.emit(this.selectedPackagingUnitIds);
  }

  isPackagingUnitSelected(item: PackagingUnitInfoDto) {
    if (this.selectedPackagingUnitIds && this.selectedPackagingUnitIds.length > 0) {
      return this.selectedPackagingUnitIds.includes(item.id);
    }
  }

  private openDeleteDialog(packagingUnits: number[]) {
    const dialogData: DeleteDialogData = {
      dialogHeader: this.translateService.translate('packagingUnit.deletePackagingUnitsHeader'),
      dialogText: this.translateService.translate('packagingUnit.deletePackagingUnitsText'),
    };
    const dialogRef = this.dialog.open(DeleteItemDialogComponent, getDialogConfig(dialogData, '500px'));
    this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result.event === DialogActions.DELETE) {
        this.deletePackagingUnits(packagingUnits);
      }
    });
  }

  emptyRecyclingBin() {
    if (!this.isRecyclingBinSelected) {
      console.log('PackagingUnitsOverviewComponent: Recycling bin must be selected prior to emptying.');
      return;
    }
    this.deletePackagingUnits(this.dataSource.data.map(x => x.id));
  }

  private refreshDataSourceAfterChange(filterPredicate: (value: PackagingUnitInfoDto) => boolean) {
    if (this.dataSource instanceof PaginationDataSource) {
      this.refreshDataSource();
    } else {
      this.dataSource.data = this.dataSource.data.filter(filterPredicate);
    }
  }

  private deletePackagingUnits(packagingUnits: number[]) {
    this.spinner.show();
    const deletePermamently = this.isRecyclingBinSelected;
    const toDeleteDto = new DeletedEntitiesDto();
    toDeleteDto.deleted = [];
    for (const packagingId of packagingUnits) {
      if (packagingId != null) {
        toDeleteDto.deleted.push({ id: packagingId, version: 0 });
      }
    }
    this.deleteBackendSubscription = this.packagingUnitApiService.deletePackagingUnits(toDeleteDto, deletePermamently, true).subscribe({
      next: _ => {
        this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(this.getDeletePackagingUnitSuccessData(), '500px'));
        this.refreshDataSourceAfterChange(value => !toDeleteDto.deleted.map(x => x.id).includes(value.id ?? -1));
        this.spinner.hide();
      },
      error: e => {
        if (e.status === 403) {
          this.dialog.open(PackagingUnitUsageInEvalDialogComponent, getDialogConfig(this.getPackagingUnitUsedData(e), '500px'));
        } else {
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(this.getDeletePackagingUnitErrorData(), '500px'));
        }
        this.spinner.hide();
      },
    });
    this.resetSelection();
    this.packagingPartsSelected.emit(this.selectedPackagingUnitIds);
  }

  private getDeletePackagingUnitSuccessData(): SimpleDialogData {
    return {
      title: this.translateService.translate('common.text.success'),
      messages: [this.translateService.translate('dataManagement.directory.dialog.removal.packagingUnitsDeletedSuccess')],
      icon: 'info',
    };
  }

  private getPackagingUnitUsedData(error: HttpErrorResponse) {
    return {
      title: this.translateService.translate('common.text.error'),
      icon: 'error',
      exceptionReasons: error.error.exceptionReasons ?? [],
    };
  }

  private getDeletePackagingUnitErrorData(): SimpleDialogData {
    return {
      title: this.translateService.translate('common.text.error'),
      messages: [this.translateService.translate('dataManagement.directory.dialog.removal.packagingUnitsDeletedError')],
      icon: 'error',
    };
  }

  restorePackagingPart() {
    this.restorePackagingUnits(this.selectedPackagingUnitIds);
  }

  restoreAllPackagingUnits() {
    this.restorePackagingUnits(this.dataSource.data.map(x => x.id));
  }

  private restorePackagingUnits(packagingUnitIds: number[]) {
    if (!this.isRecyclingBinSelected) {
      console.log('PackagingUnitsOverviewComponent: Recycling bin must be selected prior to restoring.');
      return;
    }
    for (const packagingUnitId of packagingUnitIds) {
      this.refreshDataSourceAfterChange(value => {
        return value.id !== packagingUnitId;
      });
      if (packagingUnitId != null) {
        this.restoreSubscription = this.directoryApiService.restorePackagingUnitFromRecyclingBin(packagingUnitId).subscribe(_ => {
          window.location.reload();
        });
      }
    }
  }

  navigateToPackagingUnit(packagingUnit: PackagingUnitDto) {
    if (packagingUnit.packagingTypeId != null) {
      this.packagingUnitTypeService.setLastSelectedTypeId(packagingUnit.packagingTypeId);
    }
    if (packagingUnit.id != null) {
      this.navigationService.navigateToPackagingUnit(packagingUnit.id);
    }
  }

  getPackagingUnitTypes(): { name: string; value: any }[] {
    return this.packagingUnitTypeService.getPackagingUnitTypes().map(x => ({ name: x.name, value: x.id }));
  }

  getFillingGoodTypeOptions(): { name: string; value: any }[] {
    return this.fillingGoodTypes.map(x => ({ name: x.name, value: x.externalId }));
  }

  getFillingGoodCategoryOptions(): { name: string; value: any }[] {
    return this.fillingGoodCategories.map(x => ({ name: x.name, value: x.externalId }));
  }

  getFillingGoodOptions(): { name: string; value: any }[] {
    return this.fillingGoods.map(x => ({ name: x.name, value: x.externalId }));
  }

  selectAllPackagingUnitsButtonClick() {
    this.selectAllPackagingUnits();
  }

  public selectAllPackagingUnits() {
    this.allItemsSelected = !this.allItemsSelected;
    this.selectedPackagingUnitIds = [];
    if (this.allItemsSelected) {
      for (const packagingUnitId of this.packagingUnitIds) {
        this.selectedPackagingUnitIds.push(packagingUnitId);
      }
    }
    this.packagingPartsSelected.emit(this.selectedPackagingUnitIds);
  }

  getTagsSettingFunction(isEditing: boolean) {
    return (id: number, tagIds: number[]) =>
      isEditing ? this.packagingUnitApiService.setPackagingUnitTags(id, tagIds) : this.packagingUnitApiService.addPackagingUnitTags(id, tagIds);
  }

  getPackagingPartFunction() {
    return (id: number) => this.packagingUnitApiService.getPackagingUnit(id);
  }

  resetSelection() {
    this.selectedPackagingUnitIds = [];
    this.allItemsSelected = false;
    this.packagingPartsSelected.emit(this.selectedPackagingUnitIds);
  }

  isGenericPackaging(packagingUnitTypeId: number) {
    return this.packagingUnitTypeService.isPackagingUnitTypeGeneric(packagingUnitTypeId);
  }

  movePackagingPart(rootFolder: DirectoryDto, unreachableFolders: DirectoryDto[]) {
    const data = { rootFolder, unreachableFolders };
    const dialogConfig = getDialogConfig(data, '500px');
    const dialogRef = this.dialog.open(SelectLocationDialogComponent, dialogConfig);
    this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result.event === DialogActions.REJECT) {
        return;
      }
      const observables = this.selectedPackagingUnitIds
        .filter(id => id != null)
        .map(packagingUnitId => {
          return this.directoryApiService.movePackagingUnit(result.data.id, packagingUnitId);
        });
      this.moveBackendSubscription = forkJoin(observables).subscribe(_ => {
        this.dataChanged.emit();
        this.refreshDataSourceAfterChange(value => this.selectedPackagingUnitIds.includes(value.id ?? -1));
      });
    });
  }

  copyPackagingPart(rootFolder: DirectoryDto, unreachableFolders: DirectoryDto[]) {
    const data = { rootFolder, unreachableFolders };
    const dialogConfigFolderSelection = getDialogConfig(data, '500px');
    const dialogRefFolderSelection = this.dialog.open(SelectLocationDialogComponent, dialogConfigFolderSelection);
    this.dialogSubscription = dialogRefFolderSelection.afterClosed().subscribe(foldersResult => {
      if (foldersResult.event === DialogActions.REJECT) {
        this.spinner.hide();
        return;
      }
      this.doCopy(foldersResult.data.id);
      // TODO uncomment when functionality in backend available
      /* if (!dialogConfigTrackingSelection) {
        this.doCopy(foldersResult.data.id);
      } else {
        const dialogRefTrackingSelection = this.dialog.open(CopyWithTrackingComponent, dialogConfigTrackingSelection);
        dialogRefTrackingSelection.afterClosed().subscribe(trackingResult => {
          if (trackingResult.event !== DialogActions.REJECT) {
            this.doCopy(foldersResult.data.id);
          }
        });
      } */
    });
  }

  private doCopy(folderId: number) {
    const observables = this.selectedPackagingUnitIds.map(packagingUnitId => {
      if (packagingUnitId != null) {
        return this.directoryApiService.copyPackagingUnit(folderId, packagingUnitId);
      }
      return of(null);
    });
    this.copyBackendSubscription = forkJoin(observables).subscribe({ next: _ => this.dataChanged.emit(), error: _ => this.spinner.hide() });
  }

  deletePackagingPart(itemsToDelete = this.selectedPackagingUnitIds) {
    this.spinner.show();
    const observables = itemsToDelete
      .filter(packagingId => packagingId != null)
      .map(packagingId => {
        return this.packagingUnitApiService.getPackagingUnitPermissions(packagingId);
      });
    this.permissionsSubscription = forkJoin(observables).subscribe((permissionsList: PermissionTypeDto[]) => {
      if (permissionsList.filter(x => x.delete === false).length > 0) {
        this.spinner.hide();
        this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(this.getDeleteNotAllowedData(this.translateService), '500px'));
      } else {
        this.spinner.hide();
        this.openDeleteDialog(itemsToDelete);
      }
    });
  }

  exportPackagingPart() {
    this.spinner.show();
    const observables = this.selectedPackagingUnitIds.map(packagingUnitId => {
      return this.analysisApiService.isRecyclabilityAnalysisPossible(packagingUnitId, true, PackagingPart.Unit);
    });
    this.recSubscription = forkJoin(observables).subscribe(returnList => {
      const proceedWithExport = !returnList.includes(false);
      const dialogConfig = getDialogConfig({ packagingUnitIds: this.selectedPackagingUnitIds }, '50%');
      if (proceedWithExport) {
        this.doExport(dialogConfig);
      } else {
        const data: SimpleDialogData = {
          title: this.translateService.translate('common.text.warning'),
          messages: [this.translateService.translate('warnings.exportIncompletePackagingUnit')],
          icon: 'warning',
        };
        const confirmDialogConfig = getDialogConfig(data, '350px');
        const dialogRef = this.dialog.open(SimpleConfirmDialogComponent, confirmDialogConfig);
        this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
          if (result.event === DialogActions.REJECT) {
            this.spinner.hide();
            return;
          } else {
            this.doExport(dialogConfig);
          }
        });
      }
    });
  }

  private async doExport(dialogConfig: MatDialogConfig) {
    const exportProfilesFunction = () => this.importExportApiService.getPackagingUnitExportProfiles();
    const exportFunction = (packagingId: number, principalId: number, profileId?: number) => this.importExportApiService.exportPackagingUnit(packagingId, principalId, profileId);
    super.exportItems(dialogConfig, exportProfilesFunction, exportFunction);
    this.resetSelection();
  }

  getAnalysisWrappersRecForPackaging(packagingUnitId: number) {
    return this.analysisWrappersRec?.find(x => x.id === packagingUnitId) ?? undefined;
  }

  getAnalysisWrappersLcaForPackaging(packagingUnitId: number) {
    return this.analysisWrappersLca?.find(x => x.id === packagingUnitId) ?? undefined;
  }

  getAnalysisIdForPackaging(packagingUnitId: number) {
    if (this.analysisWrappersRec) {
      return this.analysisWrappersRec?.find(x => x.id === packagingUnitId)?.analysisId ?? null;
    } else {
      return this.analysisWrappersLca?.find(x => x.id === packagingUnitId)?.analysisId ?? null;
    }
  }

  downloadPackagingUnitsJson() {
    const packagingUnitsToDownload: { id: number; version: number }[] = [];
    this.selectedPackagingUnitIds.forEach(packagingUnitId => {
      if (packagingUnitId != null) {
        packagingUnitsToDownload.push({ id: packagingUnitId, version: 0 });
      }
    });
    this.jsonSubscription = this.packagingUnitApiService.downloadPackagingUnitsJson(packagingUnitsToDownload).subscribe(zipFile => {
      const zipUrl = window.URL.createObjectURL(zipFile);
      window.open(zipUrl, '_blank', 'noreferrer');
    });
  }

  downloadPackagingUnitsEXCEL() {
    const packagingUnitsToDownload: { id: number; version: number }[] = [];
    this.selectedPackagingUnitIds.forEach(packagingUnitId => {
      if (packagingUnitId != null) {
        packagingUnitsToDownload.push({ id: packagingUnitId, version: 0 });
      }
    });
    this.checkPackagingUnits(packagingUnitsToDownload);
  }

  checkPackagingUnits(idvs: { id: number; version: number }[]) {
    const checkObservable: Observable<any>[] = [];
    let faultyIds: number[] = [];
    idvs.forEach(idv => checkObservable.push(this.templateApiService.checkPUsStructureForExcelTemplate([idv])));
    forkJoin(checkObservable).subscribe(results => {
      for (let i = 0; i < results.length; i++) {
        if (results[i] == false) {
          faultyIds.push(idvs[i].id);
        }
      }
      if (faultyIds.length == 0) {
        this.excelSubscription = this.templateApiService.getPUImporterTemplateWithData(idvs).subscribe(fileToSave => {
          downloadDocument(fileToSave);
        });
      } else {
        let faultyIdString: string = faultyIds.reduce((acc, currentValue) => currentValue.toString() + ', ' + acc.toString(), '');
        const data: SimpleDialogData = {
          title: this.translateService.translate('common.text.error'),
          messages: [this.translateService.translate('dataManagement.directory.toolbar.downloadErrors.NotValidStructure', { packagingUnits: faultyIdString })],
          icon: 'error',
        };
        const alertDialogConfig = getDialogConfig(data, '350px');
        this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
      }
    });
  }

  getPackagingUnitTypeImage(packagingUnitTypeId: number) {
    return this.packagingUnitTypeService.getPackagingUnitTypeImage(packagingUnitTypeId);
  }

  getFormControlForQuantity(element: PackagingUnitDto) {
    return (this.quantityForms.controls.find(control => control.value.id === element.id) as FormGroup).controls.quantity as FormControl;
  }

  addCountryToPackaging(packagingUnit: PackagingUnitDto) {
    this.distributionCountryAdded.emit({ id: packagingUnit.id, version: packagingUnit.version });
  }

  comparePackagingPart() {
    const observablesPermissions = this.selectedPackagingUnitIds
      .filter(packagingUnitId => packagingUnitId != null)
      .map(packagingUnitId => {
        return this.packagingUnitApiService.getPackagingUnitPermissions(packagingUnitId);
      });
    this.permissionsSubscription = forkJoin(observablesPermissions).subscribe((permissionsList: PermissionTypeDto[]) => {
      const isComparisonPermitted = permissionsList.map(x => x.analyze).find(x => x === false) === undefined;
      if (!isComparisonPermitted) {
        this.navigationService.stopWhenAnalysisNotPermitted();
        return;
      }
      const listOfIds: number[] = this.selectedPackagingUnitIds.filter(id => id != null).map(id => id ?? -1);
      this.comparisonDataService.setPackagingVersionMapping(this.selectedPackagingUnitIds);

      this.navigationService.navigateToComparison(listOfIds);
    });
  }

  editPackagingPartQuantity() {
    const dialogConfig = getDialogConfig({ packagingUnitIds: this.selectedPackagingUnitIds }, '900px');
    const dialogType: any = this.selectedPackagingUnitIds.length > 1 ? EditQuantitiesDialogComponent : EditQuantityDialogComponent;
    this.dialog.open(dialogType, dialogConfig);
  }

  onPageChanged(event: PageEvent) {
    if (this.dataSource instanceof PaginationDataSource) {
      this.dataSource.fetchData(event.pageIndex, event.pageSize);
    }
  }

  onSortChanged(event: Sort) {
    if (this.dataSource instanceof PaginationDataSource) {
      if (event.direction) {
        this.dataSource.sort(this.getPaginationFieldName(event.active), event.direction == 'asc');
      } else {
        this.dataSource.removeSorting();
      }
    }
  }

  getPaginationFieldName(column: string) {
    switch (column) {
      case 'id':
        return PackagingUnitPaginationFields.Id;
      case 'directoryName':
        return PackagingUnitPaginationFields.DirectoryId;
      case 'tags':
        return PackagingUnitPaginationFields.Tag;
      case 'packagingTypeName':
        return PackagingUnitPaginationFields.PackagingType;
      case 'brandName':
        return PackagingUnitPaginationFields.BrandName;
      case 'productName':
        return PackagingUnitPaginationFields.ProductName;
      case 'articleNumber':
        return PackagingUnitPaginationFields.ArticleNumber;
      case 'supplier':
        return PackagingUnitPaginationFields.Supplier;
      case 'gtin':
        return PackagingUnitPaginationFields.Gtin;
      case 'fillingGoodTypeId':
        return PackagingUnitPaginationFields.FillingGoodType;
      case 'fillingGoodCategoryId':
        return PackagingUnitPaginationFields.FillingGoodCategory;
      case 'fillingGoodId':
        return PackagingUnitPaginationFields.FillingGood;
      case 'packagingQuantity':
        return PackagingUnitPaginationFields.PackagingQuantity;
      case 'packagingVolume':
        return PackagingUnitPaginationFields.PackagingVolume;
      case 'distributionCountries':
        return PackagingUnitPaginationFields.DistributionLocations;
      case 'assemblyCountry':
        return PackagingUnitPaginationFields.AssemblyLocation;
      case 'length':
        return PackagingUnitPaginationFields.Length;
      case 'width':
        return PackagingUnitPaginationFields.Width;
      case 'height':
        return PackagingUnitPaginationFields.Height;
      case 'creationTimestamp':
        return PackagingUnitPaginationFields.CreationTimestamp;
      case 'lastModificationTimestamp':
        return PackagingUnitPaginationFields.LastModificationTimestamp;
      case 'hasImagess':
        return PackagingUnitPaginationFields.HasImages;
      case 'hasCertificates':
        return PackagingUnitPaginationFields.HasCertificates;
      case 'hasAdditionalDocuments':
        return PackagingUnitPaginationFields.HasAdditionalDocuments;
      case 'hasPPWRDocuments':
        return PackagingUnitPaginationFields.HasPPWRDocuments;
      case 'packagingLevel':
        return PackagingUnitPaginationFields.PackagingLevel;
      case 'isPackagingPartOfProduct':
        return PackagingUnitPaginationFields.IsPackagingPartOfProduct;
      case 'isMultiUsePackaging':
        return PackagingUnitPaginationFields.IsMultiUsePackaging;
    }

    return '';
  }

  getStatusOptions(): { name: string; value: string }[] {
    if (!this.subRequestMap) {
      return [];
    }
    const labels = [...this.subRequestMap.values()].map(s => this.translateService.translate(this.getSubRequestStatusLabel(s.status))).filter(Boolean) as string[];
    return [...new Set(labels)].sort().map(label => ({ name: label, value: label }));
  }

  getCaller(columnName: string) {
    if (this.isPaginatorVisible) {
      return this.getPaginationFieldName(columnName);
    }

    return columnName;
  }

  createDataExchangeRequest(): void {
    this.openCreateDataExchangeRequestDialog({ allPrincipals: [], packagingUnitIds: this.selectedPackagingUnitIds }, dto =>
      this.dataExchangeRequestApiService.createDataExchangeRequest(dto, true)
    );
    this.resetSelection();
  }

  protected isPackagingSystem(): boolean {
    return false;
  }

  protected getSelectedIds(): number[] {
    return this.selectedPackagingUnitIds;
  }

  protected fetchDocProblems(requestDto: CreateDocTdRequestDto) {
    return this.ppwrApiService.getDocProblemsForUnits(requestDto, true);
  }

  protected generateDocBlob(requestDto: CreateDocRequestDto) {
    return this.ppwrApiService.generateDocForUnits(requestDto, true);
  }

  protected generateTechnicalDocBlob(requestDto: CreateDocTdRequestDto) {
    return this.ppwrApiService.generateTechnicalDocumentationForUnits(requestDto, true);
  }
}
